import {Link} from 'react-router-dom';
import React, {useState, useEffect, useRef, useContext } from 'react';
import GoogleAds from './googleads';
import DOMPurify from 'dompurify';
import ShareButtons from './socialshare';
import SocialSharing from './socialmediashare';



const  FeedItem = React.forwardRef((props, ref)=>{
let baseurl = window.location.origin
var n = 0;
const [listvalue,setListValue] = useState([]);
    
const Listify = (tg) => {

    let items = tg.split(",");

    return items;
    
}

const [items, setItems] = useState([]);
const [host, setHost] = useState("myjoyonline.com")
const [articleid, setArticleid] = useState(props.id)


 
  useEffect(()=>{
    setListValue(props.tags);
  },[props.tags, props.category]);



    return( 
    
    
    <div>
      
      {
             
            <div ref={ref} className="feeditem">
        <a href={"/"+props.storyurl.slice(0,props.storyurl.length-1)}>
            <div className="categoryLabel"><span>{props.datepublished}</span><span>
            
            {
              props.category.map((lcat,index)=>{

                if(lcat.catname !== "" && lcat.catname.search("HP ") == -1 && index < props.category.length-1){



                  return(
                    <span>
                          <Link key={index} to={{pathname:"/"+lcat.catpath.toLowerCase() ,  state:{category:lcat.catname}}}>{lcat.catname}</Link><span>,</span>
                    </span>
                  )
                }else if(lcat.catname.search("HP ") > -1){
                      
                  
                  return

                  
                }else{

                  return(
                  
                  
                  <Link key={index} to={{pathname:"/"+lcat.catpath.toLowerCase() ,  state:{category:lcat.catname}}}>{lcat.catname}</Link>)
                
                }

              })
            
            
            }
            </span>
            
            </div>
            <div className="titleLabel">
              
              <a href={"/"+props.storyurl.slice(0,props.storyurl.length-1)} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(props.title)}}></a>
              </div>
          
              <div className="tagLabel">{
                    listvalue.map((lst,index) =>{ 
                    
                      if(lst !== ""){
                    
                   return ( <Link key={index} to={{pathname:"/tag/"+lst.slug, state:{tagslug:lst.slug,tagname:lst.name}}}  dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(lst.name)}}></Link>)
                  }
                      }
                    
                    )
                      
            }</div>
            
            {
              
              props.image !== "no" ? 
              <div className="storyImage img-holder"><a href={"/"+props.storyurl.slice(0,props.storyurl.length)}><img src={props.image} alt={props.title} width="" className="lazy loaded"/></a></div>
              :<div ></div>
          }
            <div className="storySummary" >
            <div style={{color:"rgb(151 146 146)", fontSize:"12px", margin:"10px 0px"}}>Source: {props.source}</div>
            <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(props.summary)}}></div>
            </div>

          <div className="interactiveicons">

          <SocialSharing title={props.title} url={baseurl+"/"+props.storyurl.slice(0,props.storyurl.length)}  tags={listvalue} />
          </div>
            </a>
        </div>
        }
        </div>
    );
})



export default FeedItem;